import React from "react";
import './Section2.css';

function Section2() {
  return (
    <div className="section2">
      <div className="part1">
        <h3>What to buy now ?</h3>
        <h1>NEWEST LOOKBOOKS</h1>
      </div>
    </div>
  );
}

export default Section2;
